module.exports = __webpack_public_path__ + "assets/img/left_5.ff1e08ea.png";